import {LTServices} from "../../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {IGeoAppScope} from "../geoapp";
import {L} from "../../lt-ng/landcare-toolkit";
import someNodes = L.tree.someNodes;
import {ILayerTreeManipulationService} from "../../services/oe/layer-tree-manipulation";
import Item = L.tree.Item;
import {ILocalDataLayers} from "../../services/local-data/service/LocalDataLayers";

interface ILayerGroup {
	name: string;
	children: L.tree.Item[];
	layerFilter?: (n: L.tree.Item) => boolean;
	expandedNodes: L.tree.Item[];
	hide?: boolean;
}

interface ILayerGroupScope extends IGeoAppScope {
	layerGroups: ILayerGroup[]
	anyChildrenAreIncluded(group: ILayerGroup, layerFilter?: (Item) => boolean) : boolean;
}

export class LayerGroupCtrl {
	public static $inject = [
		'$scope',
		'landcareMapService',
		'layerTreeManipulationService',
		'localDataLayers'
	];

	constructor($scope: ILayerGroupScope,
				mapService: IMapService,
				layerTreeManipulationService: ILayerTreeManipulationService,
				localDataLayers: ILocalDataLayers) {

		const localLayerFilter = (n: Item) => {
			if (n === localDataLayers.rootNode) {
				return n.children.length && someNodes(n.children, (item: Item) => {
					const state = item.extraState.metaLayerSelector
					return state.checked && !state.deleting;
				});
			}

			return !n.extraState.metaLayerSelector.deleting;
		}

		const localDataGroup: ILayerGroup = {
			name: localDataLayers.rootNode.name,
			children: [localDataLayers.rootNode],
			hide: true,
			layerFilter: localLayerFilter,
			get expandedNodes() {
				return layerTreeManipulationService.expandedNodes;
			},
			set expandedNodes(nodes: Item[]) {
				console.log('set expandedNodes');
				layerTreeManipulationService.expandedNodes = nodes;
			}
		}

		$scope.$on('onTreeChange', () => {
			localDataGroup.hide = !localLayerFilter(localDataLayers.rootNode)
		})

		const contextGroup: ILayerGroup = {
			name: 'Context layers',
			children: [],
			layerFilter: (n) => {
				if (n === localDataLayers.rootNode) return false;

				if (n == mapService.getCustomLayerGroup()) {
					return someNodes(n.children, (c) => {
						return $scope.nodeIsIncluded(c)
							&& c.layerType == 'CONTEXT'
					});
				}
				return $scope.nodeIsIncluded(n) && (!n.isCustom || n.layerType == 'CONTEXT') || !!n.classId
			},
			get expandedNodes() {
				return layerTreeManipulationService.expandedNodes;
			},
			set expandedNodes(nodes: Item[]) {
				console.log('set expandedNodes');
				layerTreeManipulationService.expandedNodes = nodes;
			}
		};

		const scienceGroup: ILayerGroup = {
			name: 'Science and content layers',
			children: [],
			layerFilter: (n) => {
				if (n === localDataLayers.rootNode) return false;

				if (n == mapService.getCustomLayerGroup()) {
					return someNodes(n.children, (c) => $scope.nodeIsIncluded(c) && c.layerType == 'SCIENCE');
				}
				return $scope.nodeIsIncluded(n) &&
					(!n.isCustom || ['CONTEXT', "BASE"].indexOf(n.layerType) == -1) || !!n.classId;
			},
			get expandedNodes() {
				return layerTreeManipulationService.expandedNodes;
			},
			set expandedNodes(nodes: Item[]) {
				console.log('set expandedNodes');
				layerTreeManipulationService.expandedNodes = nodes;
			}
		};

		const baseGroup: ILayerGroup = {
			name: 'Basemap',
			children: [],
			layerFilter: (n) => {
				if (n === localDataLayers.rootNode) return false;

				if (n == mapService.getCustomLayerGroup()) {
					return someNodes(n.children, (c) => $scope.nodeIsIncluded(c) && c.layerType == 'BASE');
				}
				return $scope.nodeIsIncluded(n) && (!n.isCustom || n.layerType == "BASE" || !!n.classId)
			},
			get expandedNodes() {
				return layerTreeManipulationService.expandedNodes;
			},
			set expandedNodes(nodes: Item[]) {
				console.log('set expandedNodes');
				layerTreeManipulationService.expandedNodes = nodes;
			}
		};

		$scope.layerGroups = [localDataGroup, contextGroup, scienceGroup, baseGroup];

		const onTreeDataChange = (newValue : L.tree.Item[]) => {
			if (!newValue || !newValue.length) {
				contextGroup.children = [];
				scienceGroup.children = [];
				baseGroup.children = [];

				return;
			}
			const context = newValue.filter((n) => n.checkBehavior == "UNION");
			let science = newValue.filter((n) => !n.checkBehavior);
			const base = newValue.filter((n) => n.checkBehavior == "BASEMAP")
				.filter((n) => n.children.some((l) => l.layerType !== "OVERVIEW"));

			const customLayerGroup = mapService.getCustomLayerGroup();

			science = science.filter((n) => n !== customLayerGroup);

			contextGroup.children = [customLayerGroup].concat(context);
			scienceGroup.children = [customLayerGroup].concat(science);
			baseGroup.children = [customLayerGroup].concat(base);
		};

		// $scope.$watch('dataForTheTree', onTreeDataChange);

		layerTreeManipulationService.treeDataPromise.then(function () {
			onTreeDataChange(arguments[0]);
		});


		$scope.anyChildrenAreIncluded = (group: ILayerGroup, layerFilter) => {
			return someNodes(group.children, (n) => {
				return n && n.extraState.metaLayerSelector.checked && (!layerFilter || layerFilter(n));
			});
			/*let included = filterNodes(group.children,
				(n : L.tree.Item) => n && n.extraState.metaLayerSelector.checked) || [];
			if (group.layerFilter) included = included.filter(group.layerFilter);
			return included.length > 0;*/

		}
	}
}